
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { ManufacturerRelatedPayloadType } from "@/common/types/manufacturer-related";

export async function manufacturerRelatedList(
    manufacturer_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/manufacturer/${manufacturer_id}/related/list${queryString}`
    );
}

export async function manufacturerRelatedListId(
    manufacturer_id: string
) {
    return await clientAxios.get(
        `admin/manufacturer/${manufacturer_id}/related/list/id`
    );
}

export async function manufacturerRelatedGet(
    item_id: string
) {
    return await clientAxios.get(
        `admin/manufacturer/related/${item_id}/show`
    );
}

export async function manufacturerRelatedCreate(
    manufacturer_id: string,
    payload: ManufacturerRelatedPayloadType
) {
    return await clientAxios.post(
        `admin/manufacturer/${manufacturer_id}/related/create`,
        payload
    );
}

export async function manufacturerRelatedDelete(
    item_id: string,
) {
    return await clientAxios.del(
        `admin/manufacturer/related/${item_id}/delete`,
    );
}
